import { createSlice } from "@reduxjs/toolkit";

export const leadListSlice = createSlice({
  name: "leadList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedLead: null,
    filteredRecords: 0,
    isSingleLeadLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
  },
  reducers: {
    setAllLeadLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleLeadLoadingState: (state, action) => {
      state.isSingleLeadLoading = true;
    },
    loadAllLead: (state, action) => {
      const listObj = {};
      action.payload.leads.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.leads.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleLead: (state, action) => {
      state.selectedLead =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleLeadLoading = false;
    },
  },
});

export const {
  setAllLeadLoadingState,
  setSingleLeadLoadingState,
  loadAllLead,
  loadSingleLead,
} = leadListSlice.actions;

export default leadListSlice.reducer;
